<template>
  <div class="container ec-specs-container">
    <section class="ec-specs-section">
      <device-specification-entry-wrapper v-model="activeSpec" allow-close>
        <device-specification-entry v-for="entry in $props.deviceSpecification"
                                    :key="entry.code"
                                    :entry-data="entry"
                                    :name="entry.code"/>
      </device-specification-entry-wrapper>
    </section>
  </div>
</template>

<script>
import DeviceSpecificationEntry from '@/components/pdp/device-specification-entry'
import DeviceSpecificationEntryWrapper from '@/components/pdp/device-specification-entry-wrapper'

export default {
  name: 'device-specification',
  components: { DeviceSpecificationEntryWrapper, DeviceSpecificationEntry },
  data () {
    return {
      activeSpec: null
    }
  },
  props: {
    deviceSpecification: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">
.ec-specs-container {
  position: relative;
  z-index: 1;

  @media (max-width: #{map-get($grid-values, sm)}) {
    padding: 0;
  }

  @media (map_get($breakpoints, sm)) {
    &::after {
      position: absolute;
      background-color: $white;
      bottom: 0;
      content: "";
      display: block;
      left: 50%;
      margin-left: 25%;
      top: 0;
      width: 50%;
      z-index: -1;
    }
  }
}
</style>
